/* eslint-disable angular/no-run-logic */
angular.module('record-list', [
    'event',
    'record-list.pagination',
])
    .run(['Event', 'RecordListService', function(Event, RecordListService) {
        Event.on('sessionStarted', function() {
            RecordListService.clearStatus();
        });
    }]);
